import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  createServiceRequest,
  getServices,
  removeService,
  updateServiceRequest,
} from "../../../../services/api/landing/services/servicesApi";

const getLang = () =>
  localStorage.getItem("language") === "ar" ? "ar" : "en";

const toastMessages = {
  add: {
    en: "Service created successfully!",
    ar: "تم إنشاء الخدمة بنجاح!",
  },
  addError: {
    en: "Failed to create service.",
    ar: "فشل في إنشاء الخدمة.",
  },
  update: {
    en: "Service updated successfully!",
    ar: "تم تحديث الخدمة بنجاح!",
  },
  updateError: {
    en: "Failed to update service.",
    ar: "فشل في تحديث الخدمة.",
  },
  delete: {
    en: "Service deleted successfully!",
    ar: "تم حذف الخدمة بنجاح!",
  },
  deleteError: {
    en: "Failed to delete service.",
    ar: "فشل في حذف الخدمة.",
  },
};

export const fetchServices = createAsyncThunk(
  "services/fetchServices",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getServices();
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to fetch services");
    }
  },
);

export const createService = createAsyncThunk(
  "services/createService",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await createServiceRequest(formData);
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to create service");
    }
  },
);

export const updateService = createAsyncThunk(
  "services/updateService",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await updateServiceRequest(id, formData);
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to update service");
    }
  },
);

export const deleteService = createAsyncThunk(
  "services/deleteService",
  async (serviceId, { rejectWithValue }) => {
    try {
      await removeService(serviceId);
      return serviceId;
    } catch (error) {
      return rejectWithValue("Failed to delete service");
    }
  },
);

const serviceSlice = createSlice({
  name: "services",
  initialState: {
    serviceData: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchServices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchServices.fulfilled, (state, action) => {
        state.loading = false;
        state.serviceData = action.payload;
      })
      .addCase(fetchServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createService.fulfilled, (state, action) => {
        state.serviceData.push(action.payload);
        toast.success(toastMessages.add[getLang()]);
      })
      .addCase(createService.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.addError[getLang()]);
      })
      .addCase(updateService.fulfilled, (state, action) => {
        const index = state.serviceData.findIndex(
          (service) => service.id === action.payload.id,
        );
        if (index !== -1) {
          state.serviceData[index] = action.payload;
        }
        toast.success(toastMessages.update[getLang()]);
      })
      .addCase(updateService.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.updateError[getLang()]);
      })
      .addCase(deleteService.fulfilled, (state, action) => {
        state.serviceData = state.serviceData.filter(
          (service) => service.id !== action.payload,
        );
        toast.success(toastMessages.delete[getLang()]);
      })
      .addCase(deleteService.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.deleteError[getLang()]);
      });
  },
});

export default serviceSlice.reducer;
